//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import theme from './TeamList.scss';
import classnames from 'classnames';
import TeamChip from 'common/components/core/common/TeamChip';
import { IntersectionObserverDiv } from 'common/components/core/wrappers/Div';
import { PopoverPlaceEnum } from 'common/components/core/popover/popOverFactory';
import { dashboardColors } from 'common/enums/ColorEnum';
import { TeamStatusEnum } from 'common/enums/TeamEnum';

import type { TeamId } from 'common/models/internal/TeamId';
import type { Team } from 'common/models/internal/Team';
import type { List, Map } from 'immutable';

type Props = {
    theme: Object,
    teams: Map<string, Team>,
    teamIds: List<TeamId>,
    disableObserver?: boolean,
    showOverflowTooltip?: boolean,
    selectTeamName?: (teamId: Object, team: Object) => string
};

const selectDefaultTeamName = (teamId: Object, team: Object): string => {
    return team && team.name ? team.name : teamId.teamId;
};

class TeamList extends React.PureComponent<Props> {
    static defaultProps = {
        selectTeamName: selectDefaultTeamName,
        showOverflowTooltip: true
    };

    render() {
        const {
            theme,
            teams,
            teamIds,
            disableObserver,
            showOverflowTooltip,
            selectTeamName
        } = this.props;
        return teamIds ? (
            <IntersectionObserverDiv
                popoverPreferPlace={PopoverPlaceEnum.Below}
                theme={theme}
                popoverClassName={theme.teamsPopup}
                className={classnames(theme.teamsWrap, {
                    [theme.observerDisabled]: disableObserver
                })}
                disable={disableObserver}
                alwaysShowFirstItem
                key={`${teamIds.join()}TeamList`} // For fixing flickering in virtualized cell ES-10735
            >
                {teamIds.map(teamId => {
                    const team = teams.get(teamId.teamId);
                    const name = selectTeamName(teamId, team);
                    const color =
                        team && team.color
                            ? team.color
                            : dashboardColors.black.name;

                    const isInactiveTeam: boolean =
                        !team || team.status === TeamStatusEnum.Inactive;
                    return (
                        <TeamChip
                            showOverflowTooltip={showOverflowTooltip}
                            theme={theme}
                            className={classnames(
                                theme.teamsCell,
                                theme.teamChip,
                                {
                                    [theme.inactiveTeam]: isInactiveTeam
                                }
                            )}
                            key={teamId.teamId}
                            teamName={name}
                            teamColor={color}
                        />
                    );
                })}
            </IntersectionObserverDiv>
        ) : null;
    }
}

const ThemedTeamList = themr('TeamList', theme)(TeamList);

export { TeamList as UnthemedTeamList, ThemedTeamList as TeamList };
export default ThemedTeamList;
